module.exports = __webpack_public_path__ + "static/media/1_pl.88f6d5c7.png";